<div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
        <div class="col-12 mt-5 xl:mt-0 text-center">
            <img src="assets/layout/images/404_error.svg" class="w-full md:w-6">
        </div>
        <div class="col-12 flex justify-content-center  mb-6">
            <i class="pi pi-fw pi-arrow-left text-blue-500 flex align-items-center"></i><a href="#/main">Go to Dashboard</a>
        </div>
    </div>
</div>